/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import { Routes, Route } from 'react-router';
import Dashboard from '../components/pages/Dashboard';
import AuthRoute from './AuthRoute';
import DashboardFeedback from '../components/pages/DashboardFeedback';


export default () => {

    return (
        <Routes>
            <Route path="/home" element={<AuthRoute><Dashboard /></AuthRoute>} />
            <Route path="/feedback" element={<AuthRoute><DashboardFeedback /></AuthRoute>} />
            
        </Routes>
    )

};
